"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/ResultCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _icons = require('./icons');



const icons = {
  ok: _react2.default.createElement(_icons.CheckIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 9}} ),
  bad: _react2.default.createElement(_icons.AlertIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 10}} ),
  info: _react2.default.createElement(_icons.MailIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}} ),
}








// A one-message card: a tinted icon, the title, then the body and actions.
const ResultCard = ({ tone, title, children, className }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'auth-stack', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
    , _react2.default.createElement('span', {
      className: _classBuilder2.default.call(void 0, 
        'auth-icon-circle',
        tone === 'ok' && 'auth-icon-circle--ok',
        tone === 'bad' && 'auth-icon-circle--bad',
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}

      ,  icons[tone] 
    )
    , _react2.default.createElement('h1', { className: "auth-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}},  title )
    ,  children 
  )
)

exports. default = ResultCard
